import React from "react";
import {
  Create,
  Edit,
  BooleanInput,
  TextInput,
  LongTextInput,
  ImageField
} from "admin-on-rest";
import IconTitle from "../components/icon_title";
import CollectionsForm from "./CollectionsForm";
import ImageOlaSingleInput from "../components/image";
import DependentImageInput from "../components/image/DependentImageInput";

const CollectionForm = props => (
  <CollectionsForm {...props}>
    <BooleanInput label="resources.products.fieldList.active" source="active" />
    <TextInput label="resources.collections.fieldList.name" source="name" />
    <LongTextInput
      elStyle={{ minHeight: 100 }}
      label="resources.collections.fieldList.description"
      source="description"
    />
    <DependentImageInput dependsOn={"name"} {...props}>
      <ImageOlaSingleInput
        source="banners.desktop"
        toValue={props.toValue}
        labelImage="Desktop"
        label={"resources.collections.fieldList.banners.desktop"}
        accept="image/*"
      >
        <ImageField source="src" title="title" />
      </ImageOlaSingleInput>
    </DependentImageInput>
    <DependentImageInput dependsOn={"name"} {...props}>
      <ImageOlaSingleInput
        source="banners.mobile"
        toValue={props.toValue}
        labelImage="Mobile"
        label={"resources.collections.fieldList.banners.mobile"}
        accept="image/*"
      >
        <ImageField source="src" title="title" />
      </ImageOlaSingleInput>
    </DependentImageInput>
  </CollectionsForm>
);

export const CollectionCreate = props => (
  <Create
    {...props}
    title={
      <IconTitle icon="collections" title={"resources.collections.titleNew"} />
    }
  >
    <CollectionForm {...props} />
  </Create>
);

export const CollectionEdit = props => (
  <Edit
    {...props}
    title={
      <IconTitle icon="collections" title={"resources.collections.titleEdit"} />
    }
  >
    <CollectionForm {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/collections/Create.js